import { useState } from "react";
import moment from "moment-timezone";
import _ from "lodash";

import { useProgramGroupsQuery } from "../../../api/programs.api";
import { useProgramRegistrationHistoryQuery } from "../../../api/programregistration.api";
import { RegistrationHistory } from "../../../api/program.registration.models";
import { SessionSelectionType } from "../../../api/programs.models";
import { DeleteRegistrationModal, EditActivitiesModal, EditSessionsModal } from "../../account/account-programregistrations";

const formatDateRange = (dateFrom: string, dateTo: string, includeTime: boolean) => {
	if (includeTime) {
		if (moment(dateFrom).isSame(dateTo, "day")) {
			return `${moment(dateFrom).format("dddd, LL")}: ${moment(dateFrom).format("LT")} - ${moment(dateTo).format("LT")}`;
		}
		return `${moment(dateFrom).format("LLLL")} - ${moment(dateTo).format("LLLL")}`;
	} else {
		if (moment(dateFrom).isSame(dateTo, "day")) {
			return `${moment(dateFrom).format("dddd, LL")}`;
		}
		return `${moment(dateFrom).format("dddd, MMMM D")} - ${moment(dateTo).format("dddd, LL")}`;
	}
}

export interface ProgramUpcomingRegistrationsProps {
	programGroupId?: number;
	programId?: number;
}

const ProgramUpcomingRegistrations = ({ programId, programGroupId }: ProgramUpcomingRegistrationsProps) => {
	const { data: registrations, isLoading } = useProgramRegistrationHistoryQuery();

	const upcomingRegistrations = () => {
		if (registrations === undefined)
			return [];

		var filtered = registrations.filter(r => moment(r.DateTo) > moment() && r.Deleted !== true && r.Cancelled !== true);
		if (programGroupId !== undefined) {
			filtered = filtered.filter(r => r.ProgramGroupId === programGroupId);
		}
		if (programId !== undefined) {
			filtered = filtered.filter(r => r.ProgramId === programId);
		}
		return filtered.sort((a, b) => { return moment(a.DateFrom).isAfter(moment(b.DateFrom)) ? 1 : -1});
	}

	// const noReservations = upcomingRegistrations().length === 0;

	if (isLoading)
		return <></>
		
	return <>
		{/* {noReservations && 
			<>
				<h4 className="font-weight-bold mb-4">Registrations</h4>
				<p className="text-muted">You don't have any upcoming or past registrations.</p>
			</>
		} */}

		{upcomingRegistrations().length > 0 &&
			<>
				<h5 className="font-weight-bold">Upcoming Registrations</h5>
				<p>You have the following upcoming registrations:</p>
				
				<div className="row">
					{upcomingRegistrations()?.map((registration, index) => {
						return <div key={`upcoming${index}`} className="col-sm-4 mb-4">
							<div className="card">
								<div className="card-body">
									<UpcomingRegistration registration={registration} />
								</div>
							</div>
						</div>
					})}
				</div>
				<hr className="mb-4"/>
			</>
		}
	</>
}

export default ProgramUpcomingRegistrations;

interface UpcomingRegistrationProps {
	registration: RegistrationHistory;
}

const UpcomingRegistration = ({ registration }: UpcomingRegistrationProps) => {
	const { data: programGroups } = useProgramGroupsQuery();
	const programGroup = programGroups?.find(g => g.Id === registration.ProgramGroupId);

	const [showModifySessionsModal, setShowModifySessionsModal] = useState(false);
	const [showModifyActivitiesModal, setShowModifyActivitiesModal] = useState(false);
	const [showCancelRegistrationModal, setShowCancelRegistrationModal] = useState(false);

	const canModify = moment(registration.DateTo).startOf("day") > moment().startOf("day") && programGroup !== undefined && programGroup.SessionSelectionType === SessionSelectionType.Custom && registration.Deleted === false;
	const canCancel = moment(registration.DateFrom).startOf("day") > moment().startOf("day") && registration.Cancelled === false;

	return <>
		<EditSessionsModal registration={registration} show={showModifySessionsModal} onHide={() => setShowModifySessionsModal(false)} />
		<EditActivitiesModal registration={registration} show={showModifyActivitiesModal} onHide={() => setShowModifyActivitiesModal(false)} />
		<DeleteRegistrationModal registration={registration} show={showCancelRegistrationModal} onHide={() => setShowCancelRegistrationModal(false)} />

		<div className="row">
			<div className="col-sm-12">
				<h5 className="">{registration.Program}</h5>
				<p className="small">{formatDateRange(registration.DateFrom, registration.DateTo, false)}</p>
			</div>
			
		</div>

		{/* <div className="row">
			<div className="col-sm-4 mb-3">
				<span className="small text-muted">Online Registration #</span>
				<br />
				{registration.RegistrationNumber}
			</div>
			<div className="col-sm-6 mb-3">
				<span className="small text-muted">Date Submitted</span>
				<br />
				<span>{moment(getLocalDate(registration.DateSubmitted)).format("dddd, LL")}</span>
			</div>
		</div> */}

		<div className="row">
			<div className="col-sm-12 mb-3">
				<div className="small text-muted">Participants</div>
				{registration.Participants.map((participant, index) => {
					return <span key={index}>
						{participant}
						{index !== registration.Participants.length && <br />}
					</span>
				})}
			</div>
			{/* {registration.ParentGuardians.length > 0 &&
			<div className="col-sm-12">
				<div className="small text-muted">Parents/Guardians</div>
				{registration.ParentGuardians.map((parentGuardian, index) => {
					return <span key={index}>
						{parentGuardian.Name}
						{index < registration.ParentGuardians.length - 1 && <br />}
						{index === registration.ParentGuardians.length - 1 && <>
							<br />
							<small>
							Location: {registration.ParentGuardians[0].Location}, 
							Emergency Contact: {registration.ParentGuardians[0].EmergencyContact}
							</small>
						</>}
					</span>
				})}
			</div>
			} */}
		</div>
		
		{registration.Sessions.some(s => s.Sessions.length > 0) && <>
			{/* <div className="row">
				<div className="col-sm-12">
					<div className="small text-muted">Sessions</div>
					<div className="row">
					{registration.Sessions.map((session, index, arr) => {
						return <div className="col-sm-12 mb-3" key={index}>
							{registration.Participants.length > 1 && 
							<span className="font-weight-bold">{session.Participant}:</span>
							}
							{session.Sessions.sort((a, b) => { return moment(a.DateFrom).isSameOrAfter(moment(b.DateFrom)) ? 1 : -1 }).map((s, index2, arr2) => {
								return <div className="small" key={index2}>
									{formatDateRange(s.DateFrom, s.DateTo, true)}
									{s.WaitList === true && ' (on wait list)'}
									{index2 === arr2.length - 1 && <br />}
								</div>
							})}
						</div>
					})}
					</div>
				</div>
				
			</div> */}

			{/* {registration.Activities.length > 0 &&
			<div className="row">
				<div className="col-sm-12">
					<div className="small text-muted">Skills</div>
					{registration.Activities.map((activity, index, arr) => {
						return <div key={index}>
							{registration.Participants.length > 1 && 
							<span>{activity.Participant}: </span>
							}
							{activity.Activities.map((a, index2, arr2) => {
								return <span key={index2} className="">
									{a}
									{index2 < arr2.length - 1 && ', '}
								</span>
							})}
						</div>
					})}
				</div>
				<div className="col-sm-4 mb-2">
					{canModify && <>
						<button onClick={() => setShowModifyActivitiesModal(true)} className="btn btn-primary btn-block font-weight-bold font-weight-bold mb-2" style={{ lineHeight: '1.3em' }}>Modify Skills...</button>
					</>}
				</div>
			</div>
			} */}

			<div className="row">
				<div className="col-sm-12">
					{canModify && <>
						<button onClick={() => setShowModifySessionsModal(true)} className="btn btn-primary btn-sm btn-block font-weight-bold" style={{ lineHeight: '1.3em' }}>Modify Sessions...</button>
					</>}
					{registration.Activities.length > 0 && canModify && <>
						<button onClick={() => setShowModifyActivitiesModal(true)} className="btn btn-primary btn-sm btn-block font-weight-bold" style={{ lineHeight: '1.3em' }}>Modify Skills...</button>
					</>}
					{canCancel && <>
						<button onClick={() => setShowCancelRegistrationModal(true)} className="btn btn-danger btn-sm btn-block font-weight-bold" style={{ lineHeight: '1.3em' }}>Cancel Registration...</button>
					</>}
				</div>
			</div>
		
		</>}

		{/* <div className="row">
			<div className="col-sm-4 mb-3 mb-sm-0">
				<div className="small text-muted">Total Cost (including taxes)</div>
				{registration.Cost > 0 ? currency.format(registration.Cost) : "No charge"}
			</div>
			{registration.Cost > 0 &&
			<div className="col-sm-4 mb-3 mb-sm-0">
				<div className="small text-muted">Amount Paid</div>
				{currency.format(registration.Cost)}
				{registration.ReceiptURL &&
				<span> <a href={registration.ReceiptURL} target="_blank" rel="noreferrer">View Receipt</a></span>
				}
			</div>
			}
			{registration.Refunded > 0 &&
				<div className="col-sm-4 mb-3 mb-sm-0">
					<div className="small text-muted">Refunded Amount</div>
					{currency.format(registration.Refunded)}
				</div>
			}
		</div> */}
	</>
}